import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
    providedIn: 'root'
})
export class LayoutService {
    private sidebarCollapsedSubject = new BehaviorSubject<boolean>(false);
    sidebarCollapsed$ = this.sidebarCollapsedSubject.asObservable();

    private mobileSidebarOpenSubject = new BehaviorSubject<boolean>(false);
    mobileSidebarOpen$ = this.mobileSidebarOpenSubject.asObservable();

    toggleSidebar() {
        this.sidebarCollapsedSubject.next(!this.sidebarCollapsedSubject.value);
    }

    setSidebarCollapsed(collapsed: boolean) {
        this.sidebarCollapsedSubject.next(collapsed);
    }

    get isSidebarCollapsed(): boolean {
        return this.sidebarCollapsedSubject.value;
    }

    toggleMobileSidebar() {
        this.mobileSidebarOpenSubject.next(!this.mobileSidebarOpenSubject.value);
    }

    closeMobileSidebar() {
        this.mobileSidebarOpenSubject.next(false);
    }
}
